export function assetGridPageFromSearch(searchParams: URLSearchParams) {
  const page = Number(searchParams.get("page[number]"));
  const size = Number(searchParams.get("page[size]"));

  return {
    pageNumber: Number.isInteger(page) && page > 0 ? page - 1 : 0,
    pageSize: Number.isInteger(size) && size > 0 ? size : 25,
  };
}
